// extracted by mini-css-extract-plugin
module.exports = {"container":"Select_container__1e2jS","wide":"Select_wide__YjMxN"};